class DateFormat {

    static format(date) {
        if(!date) {
            return "";
        }
        let formattedDate =  new Date(date);
        return formattedDate.toLocaleDateString("en-GB")
    }
}
export default DateFormat